var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_292_9626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 16,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2977 6.41654C16.2977 8.94779 14.2458 10.9998 11.7146 10.9998C9.18335 10.9998 7.1314 8.94779 7.1314 6.41654C7.1314 3.88529 9.18335 1.83331 11.7146 1.83331C14.2458 1.83331 16.2977 3.88529 16.2977 6.41654Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07593 17.1112C4.07593 14.5799 6.12788 12.5279 8.65908 12.5279H14.77C17.3012 12.5279 19.3531 14.5799 19.3531 17.1112V17.875C19.3531 19.1407 18.3271 20.1666 17.0615 20.1666H6.3675C5.1019 20.1666 4.07593 19.1407 4.07593 17.875V17.1112Z",
    fill: "#ffffff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_292_9626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.54822,
    y: 1.83249,
    width: 18.3326,
    height: 18.3329,
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntry);
export default __webpack_public_path__ + "static/media/entry.7506e9ab10a6e4936c3f84f4a0ab8a93.svg";
export { ForwardRef as ReactComponent };